import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Home from './pages/Home';
import Catalogo from './pages/Catalogo';
import Carrinho from './pages/Carrinho';
import Perfil from './pages/Perfil';
import Historico from './pages/Historico';
import PainelVendedor from './pages/PainelVendedor';
import PainelAdmin from './pages/PainelAdmin';
import Cadastro from './pages/Cadastro';
import { db, observarAuth, buscarPerfil } from './firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

function App() {
  const [telaAtual,    setTelaAtual]    = useState('login');
  const [perfilAtivo,  setPerfilAtivo]  = useState(null);
  const [carrinho,     setCarrinho]     = useState([]);
  const [vendedorLink, setVendedorLink] = useState(null);
  const [carregando,   setCarregando]   = useState(true);

  useEffect(() => {
    const unsubscribe = observarAuth(async (user) => {
      const inicio = Date.now();
      if (user) {
        try {
          const perfil = await buscarPerfil(user.uid);
          if (perfil) {
            localStorage.setItem('perfil', JSON.stringify(perfil));
            setPerfilAtivo(perfil.perfil);
            if (telaAtual === 'login' || telaAtual === 'cadastro') {
              if (perfil.perfil === 'admin') setTelaAtual('painelAdmin');
              else if (perfil.perfil === 'vendedor') setTelaAtual('painelVendedor');
              else setTelaAtual('home');
            }
          }
        } catch (e) {
          console.error('Erro ao buscar perfil:', e);
        }
      } else {
        localStorage.removeItem('perfil');
        setPerfilAtivo(null);
        setTelaAtual('login');
      }
      const tempoDecorrido = Date.now() - inicio;
      const tempoRestante = Math.max(0, 2000 - tempoDecorrido);
      setTimeout(() => setCarregando(false), tempoRestante);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const codigoVendedor = params.get('v');
    if (codigoVendedor) {
      localStorage.setItem('vendedorLink', codigoVendedor);
      buscarVendedorPorLink(codigoVendedor);
      setTelaAtual('cadastro');
    } else {
      const linkSalvo = localStorage.getItem('vendedorLink');
      if (linkSalvo) buscarVendedorPorLink(linkSalvo);
    }
  }, []);

  async function buscarVendedorPorLink(codigo) {
    try {
      const q = query(
        collection(db, 'usuarios'),
        where('linkPersonalizado', '==', codigo),
        where('perfil', '==', 'vendedor')
      );
      const snap = await getDocs(q);
      if (!snap.empty) {
        setVendedorLink({ id: snap.docs[0].id, ...snap.docs[0].data() });
      }
    } catch (e) {
      console.error('Erro ao buscar vendedor:', e);
    }
  }

  function telaPermitida(tela, perfil) {
    if (!perfil) return tela === 'login' || tela === 'cadastro';
    if (perfil === 'admin') return true;
    if (perfil === 'vendedor') return tela !== 'painelAdmin';
    if (perfil === 'cliente') return tela !== 'painelAdmin' && tela !== 'painelVendedor';
    return false;
  }

  function handleNavegar(tela) {
    if (!telaPermitida(tela, perfilAtivo)) {
      if (!perfilAtivo) setTelaAtual('login');
      else if (perfilAtivo === 'admin') setTelaAtual('painelAdmin');
      else if (perfilAtivo === 'vendedor') setTelaAtual('painelVendedor');
      else setTelaAtual('home');
      return;
    }
    setTelaAtual(tela);
  }

  function handleLogin(perfil) {
    setPerfilAtivo(perfil);
    localStorage.removeItem('vendedorLink');
    if (perfil === 'vendedor') setTelaAtual('painelVendedor');
    else if (perfil === 'admin') setTelaAtual('painelAdmin');
    else setTelaAtual('home');
  }

  function handleLogout() {
    setPerfilAtivo(null);
    setCarrinho([]);
    setTelaAtual('login');
  }

  function handleAdicionarCarrinho(produto) {
    setCarrinho(prev => {
      const existe = prev.find(i => i.cod === produto.cod);
      if (existe) {
        return prev.map(i => i.cod === produto.cod ? { ...i, qtd: i.qtd + produto.qtd } : i);
      }
      return [...prev, produto];
    });
  }

  function handleRemover(cod) {
    setCarrinho(prev => prev.filter(i => i.cod !== cod));
  }

  function handleAlterarQtd(cod, novaQtd) {
    if (novaQtd <= 0) {
      setCarrinho(prev => prev.filter(i => i.cod !== cod));
    } else {
      setCarrinho(prev => prev.map(i => i.cod === cod ? { ...i, qtd: novaQtd } : i));
    }
  }

  const telasConhecidas = [
    'login', 'home', 'catalogo', 'carrinho',
    'perfil', 'historico', 'painelVendedor',
    'painelAdmin', 'cadastro'
  ];

  const perfilCompleto = JSON.parse(localStorage.getItem('perfil') || 'null');

  // Splash Screen
  if (carregando) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0a1628 0%, #003366 60%, #0a1628 100%)',
      }}>
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
          <div>
            <div style={{ fontSize: 52, fontWeight: 900, color: '#fff', letterSpacing: 6 }}>
              APOIO
            </div>
            <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', letterSpacing: 5, textTransform: 'uppercase', marginTop: 6 }}>
              MATERIAIS ELETRICOS
            </div>
          </div>
          <div style={{ width: 160, height: 3, background: 'rgba(255,255,255,0.15)', borderRadius: 10, overflow: 'hidden' }}>
            <div style={{
              height: '100%',
              width: '40%',
              background: 'linear-gradient(90deg, transparent, #4a90d9, transparent)',
              borderRadius: 10,
              animation: 'slide 1.2s ease-in-out infinite',
            }} />
          </div>
          <style>{`
            @keyframes slide {
              0% { transform: translateX(-200%); }
              100% { transform: translateX(400%); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f4f4f2', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 480, background: '#fff', display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

        {telaAtual === 'login' &&
          <Login onLogin={handleLogin} onNavegar={handleNavegar} />}

        {telaAtual === 'cadastro' &&
          <Cadastro
            onNavegar={handleNavegar}
            onLogin={handleLogin}
            vendedorLink={vendedorLink}
          />}

        {telaAtual === 'home' && perfilAtivo &&
          <Home perfil={perfilAtivo} onNavegar={handleNavegar} />}

        {telaAtual === 'catalogo' && perfilAtivo &&
          <Catalogo
            onNavegar={handleNavegar}
            onAdicionarCarrinho={handleAdicionarCarrinho}
            carrinho={carrinho}
          />}

        {telaAtual === 'carrinho' && perfilAtivo &&
          <Carrinho
            carrinho={carrinho}
            onNavegar={handleNavegar}
            onRemover={handleRemover}
            onAlterarQtd={handleAlterarQtd}
            perfilAtivo={perfilCompleto}
          />}

        {telaAtual === 'perfil' && perfilAtivo &&
          <Perfil
            onNavegar={handleNavegar}
            onLogout={handleLogout}
          />}

        {telaAtual === 'historico' && perfilAtivo &&
          <Historico
            onNavegar={handleNavegar}
            perfilAtivo={perfilCompleto}
          />}

        {telaAtual === 'painelVendedor' && perfilAtivo === 'vendedor' &&
          <PainelVendedor
            onNavegar={handleNavegar}
            onLogout={handleLogout}
          />}

        {telaAtual === 'painelAdmin' && perfilAtivo === 'admin' &&
          <PainelAdmin
            onNavegar={handleNavegar}
            onLogout={handleLogout}
          />}

        {!telasConhecidas.includes(telaAtual) && (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
            <span style={{ fontSize: 40 }}>🚧</span>
            <span style={{ fontSize: 14, fontWeight: 500, color: '#1a1a1a' }}>Tela em construcao</span>
            <button onClick={() => handleNavegar('home')}
              style={{ background: '#003366', border: 'none', borderRadius: 10, padding: '10px 20px', fontSize: 13, fontWeight: 500, color: '#fff', cursor: 'pointer', marginTop: 8 }}>
              Voltar ao inicio
            </button>
          </div>
        )}

      </div>
    </div>
  );
}

export default App;
